import React from 'react';

const Spinner = () => {
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100px',
        }}>
            <div
                style={{
                    width: '40px',
                    height: '40px',
                    border: '4px solid #ccc',
                    borderTop: '4px solid #007BFF',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite',
                }}
            ></div>
        </div>
    );
};

export default Spinner;